
import i18n from '@/plugins/i18n'
export default {
  browse:{
    table:{
      headers: [
        {
          text:  i18n.t("model.prop.no"),
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text:  i18n.t("model.prop.name"),
          value: 'name',
        },
        {
          text:  "Avatar",
          value: 'avatar',
        },
        {
          text:  "Gender",
          value: 'gender',
        },
        {
          text: "Mochi Id",
          value: "playerMochiId",
        },
        // {
        //   text:  "PIN",
        //   value: 'PIN',
        // },
        {
          text:  i18n.t("model.prop.status"),
          value: 'isActive',
        },
      ],
    },
  },
  read:{
    tabs:[
      // {
      //   key:'Save',
      //   label:'saves',
      // },
      {
        key: 'Info',
        label:i18n.t("string.info"),
      },
      // {
      //   key:'Activity',
      //   label:i18n.t("model.name.activity"),
      // },
      // {
      //   key:'Performance',
      //   label:i18n.t("model.name.performance"),
      // },
    ],
    table:{
      headers: [
        {
          text:  i18n.t("model.prop.name"),
          value: 'name',
        },
        {
          text:  i18n.t("model.prop.status"),
          value: 'isActive',
        },
        {
          text:  'Mochi Id',
          value: 'mochiId',
        },
        {
          text:  "Gender",
          value: 'gender',
        },
        {
          text:  "Race",
          value: 'race',
        },
        {
          text:  'NRIC/Passport Number',
          value: 'moeNumber',
        },
        {
          text:  'Email Address (MOE Email)',
          value: 'email',
        },
        {
          text:  "Main Institution",
          value: 'mainInstitution',
        },
        {
          text:  "Main Classroom",
          value: 'mainClassroom',
        },
        {
          text:  'Password',
          value: 'password',
        },
        {
          text:  i18n.t("model.prop.created"),
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text:  i18n.t("model.prop.lastUpdated"),
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:{
    fields:[
      {
        type:'string',
        key:'name',
        name:i18n.t("model.prop.name"),
      },
      {
        type: 'string',
        key: 'moeNumber',
        name: "NRIC/Passport Number",
      },
      {
        type: 'string',
        key: 'email',
        name: "Email Address (MOE Email)",
      },
      {
        type: 'string',
        key: 'mainInstitution',
        name: "Main Institution",
      },
      {
        type: 'string',
        key: 'mainClassroom',
        name: "Main Classroom",
      },
      {
        type: 'radio',
        key: 'isActive',
        name: 'Is Active',
      },
    ],
    rules:{
      name: [v => !!v || i18n.t("rules.name")],
    },
  },
  edit:true,
  delete:true,
}